import React, { FC } from "react";
import { Button, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useOfferDetailModel } from "../offerDetailModel";
import { YhBut } from "@/components/YhButton";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IOfferDetailMethod } from "../../../offerTypes";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";

// 收汇方式
export const TableBoxMethod: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editMethodList,
        addFormVal,
        editFormVal,
        getcurrencySymbol,
        setEditMethodList, addMethodList, setAddMethodList, addMethod,
        isDisabeld
    } = useOfferDetailModel(({ editMethodList, addMethodList, editFormVal }) => [editMethodList, addMethodList, editFormVal]);
    const { getSelectedDictOne, getTreeNodeName, getSelectedDictValueOne, getTreeNodeValue } = useDictModel(() => []);
    const methodList = mode === "edit" ? editMethodList : addMethodList;
    const setMethodList = mode === "edit" ? setEditMethodList : setAddMethodList;
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    const columns = [
        {
            title: '操作',
            width: 80,
            fixed: "left",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any, i: number) =>
                record.key === "totalAmount" ?
                    "" : <>
                        <YhBut
                            type="add"
                            txt="添加"
                            click={() => addMethod(mode)}
                        />
                        <YhBut
                            type="delete"
                            txt="删除"
                            disabled={methodList.length <= 1}
                            click={() => setMethodList(origin => origin.filter(item => item.key !== record.key))}
                        />
                    </>
        }, {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '*货前后',
            width: 160,
            dataIndex: 'around',
            editable: true,
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.DEIIVERY),
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '*收汇方式',
            width: 160,
            dataIndex: 'paymentMethod',
            editable: true,
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.COLLECT_METHOD),
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '日期方式',
            width: 160,
            dataIndex: 'paymentTime',
            editable: true,
            editType: "select",
            options: getSelectedDictValueOne(DictCodeEnmu.DATE_TYPE),
            render: (text: string) => getTreeNodeValue(text)
        }, {
            title: '天数',
            width: 120,
            dataIndex: 'days',
            editable: true,
        }, {
            title: '比例%',
            width: 160,
            dataIndex: 'proportion',
        }, {
            title: '*金额',
            width: 160,
            editable: true,
            dataIndex: 'amount',
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '预计收款日期',
            width: 160,
            dataIndex: 'collectionTime',
            editable: true,
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        }, {
            title: '预计收证日期',
            width: 160,
            dataIndex: 'certificatesTime',
            editable: true,
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
    ];

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IOfferDetailMethod, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IOfferDetailMethod) => {
        //合同总金额
        let contractAmount = +formatNum(formVal.contractAmount);
        row.amount = formatNum(row.amount);
        row.proportion = `${formatNum(+row.amount / contractAmount * 100)}%`
        let dataSource = [...methodList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        //debugger
        dataSource.splice(index, 1, { ...item, ...row });
        setMethodList(dataSource);
    }

    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        ename: "",
        name: "",
        amount: methodList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0)
    }

    return (
        <YhBox title="收汇方式" style={{ marginBottom: "10px", width: "100%" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                // components={{
                //     body: {
                //         row: EditableRow,
                //         cell: EditableCell,
                //     },
                // }}
                // columns={newColumns as ColumnsType<IOfferDetailMethod>}
                components={isDisabeld(mode)
                    ? {} : {
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                columns={(isDisabeld(mode) ? columns.splice(1, columns.length - 1) : newColumns) as ColumnsType<IOfferDetailMethod>}
                dataSource={methodList.length > 0 ? [...methodList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    )
}